import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardReport1Route: InvariantJiraRoute = {
	name: 'rapidboard-report',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=reporting', 'chart'],
};
